import React, { CSSProperties } from "react";

export interface TextProps {
  color?: string;
  preset?: string;
  font?: string;
  className?: string;
  style?: CSSProperties;
  children: React.ReactNode | React.ReactNodeArray;
  id?: string;
}
